export default {"src":"/_next/static/media/logo-symbol.2de2e028.svg","height":44,"width":44};